import styled from "styled-components";

export const InnerContainer = styled.div`
  padding: 0 16px;

  @media only screen and (min-width: 700px) and (max-width: 960px) {
    padding: 0 36px;
  }
`;

export const InnerSection = styled.section`

`;
